/* Iceberg-ui */
import { Flex } from '@auviknetworks/iceberg-ui';

/* MUI */
import { Box, FormLabel, TextField, Typography } from '@mui/material';

/* Shared */
import { TooltipQ } from 'application/Shared/Components/Tooltips';

/* React */
import React from 'react';

/*  NPM  */
import { useFormContext } from 'react-hook-form';

export const FormTextInput = ({
    alignment = 'horizontal',
    autoFocus = false, // focus input on first mount
    disabled,
    inputProps = {},
    name,
    required,
    label,
    placeholder = '',
    tooltipText,
    type = 'text'
}) => {
    const { register, formState } = useFormContext();
    const { errors } = formState;
    const errorState = errors[name];
    const errorMessage = errorState?.message;

    const inputPropsWithTestId = {
        ...inputProps,
        'data-testid': `TextField-${name}`
    };

    return (
        <Flex
            data-testid={`FormTextInput-${name}`}
            mb="24px"
            style={{
                flexDirection: alignment === 'vertical' ? 'column' : 'row'
            }}
        >
            <Box
                width={alignment === 'vertical' ? '100%' : '40%'}
                display="inline-flex"
                alignItems="center"
            >
                <FormLabel
                    component="label"
                    className="anmForm"
                    required={required}
                >
                    {label}
                </FormLabel>
                {tooltipText && <TooltipQ text={tooltipText} />}
            </Box>
            <Box width={alignment === 'vertical' ? '100%' : '60%'}>
                <TextField
                    {...register(name, { disabled, required })}
                    autoFocus={autoFocus}
                    className="anmForm"
                    variant="outlined"
                    placeholder={placeholder}
                    error={!!errorState}
                    fullWidth
                    disabled={disabled}
                    inputProps={inputPropsWithTestId}
                    type={type}
                />
                {errorMessage && (
                    <Flex justifyContent="flex-start">
                        <Typography color="text.error">
                            {errorMessage}
                        </Typography>
                    </Flex>
                )}
            </Box>
        </Flex>
    );
};
